import { render, staticRenderFns } from "./Tripdaze.vue?vue&type=template&id=8f74458e&scoped=true&"
import script from "./Tripdaze.vue?vue&type=script&lang=js&"
export * from "./Tripdaze.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8f74458e",
  null
  
)

export default component.exports